import { useQuery } from "@tanstack/react-query";
import type { Business } from "@/types/business";

export function useBusinessById(rapidId: string) {
  return useQuery({
    queryKey: ["business", rapidId],
    queryFn: async () => {
      const config = await (globalThis as any)._appSettings;
      const base: string = config?.api_endpoint ?? "";
      const tenant: string = config?.directory_partner ?? "";

      const res = await fetch(`${base}api/business/${rapidId}?tenant=${encodeURIComponent(tenant)}`, {
        mode: "cors",
      });
      if (!res.ok) {
        throw new Error(`API error ${res.status}`);
      }
      return res.json() as Promise<Business>;
    },
    enabled: !!rapidId,
  });
}
